export default __webpack_public_path__ + "static/media/skill11.3fa28718.svg";